import React from 'react';
import { cn } from '@/utils/utils';
// import bn from '@/utils/bemnames';
// import { cn } from '@/utils/utils';
// import Typography from '../Typography';

// const bem = bn.create('page');

export type PageProps = {
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
};

const Page: React.FC<PageProps> = ({
  className = '',
  children,
  ...restProps
}) => {
  const classes = cn('px-4 py-4 w-full min-w-0', className);
  return (
    <div className={classes} {...restProps}>
      {children}
    </div>
  );
};

export default Page;
